import { greatIdeaForProjects } from '../../../../../img/images';
import { InstructionTickIcon } from '../../../../shared/icons/icons';
import { ILocalization } from '../../../../../localization/definitions/types';

export const GreatProjectIdeaSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='great-project-idea-slide'></div>
        </div>
    );
};

export const GreatProjectIdeaSlideImageSrc = greatIdeaForProjects;

interface Props {
    localization: ILocalization;
}

export const GreatProjectIdeaSlideContent = ({ localization }: Props) => {
    const { greatProjectIdeaSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial.user
            .slides;

    return (
        <div className='tutorial-content-wrapper' data-testid='third-slide'>
            <h1>{greatProjectIdeaSlide.haveAGreat}​​</h1>
            <h4>{greatProjectIdeaSlide.letsFillOut}</h4>

            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {greatProjectIdeaSlide.pickYour}{' '}
                    <span className='instruction-content-bold'>
                        {greatProjectIdeaSlide.researchArea}
                    </span>
                    , {greatProjectIdeaSlide.yourFirstSupervisor}
                    <div />
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    <span className='instruction-content-bold'>
                        {greatProjectIdeaSlide.send}
                    </span>{' '}
                    {greatProjectIdeaSlide.yourProjectProposal}
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {greatProjectIdeaSlide.waitFor}{' '}
                    <span className='instruction-content-bold'>
                        {greatProjectIdeaSlide.approval}
                    </span>{' '}
                    {greatProjectIdeaSlide.fromYourFirst}
                </div>
            </div>
        </div>
    );
};
